import { BasketModel } from "@/lib/basket/basket.model";

import { GetCartLineProductsQueryResult } from "@/sanity.types";

import { ToastOrderSummaryLineItem } from "../toastOrderSummary/toastOrderSummaryLineItem.component";

export const ToastOrderSummaryLineItems = ({
  products,
  lineItems,
  action,
}: ToastOrderSummaryLineItemsProps) => {
  const renderAccessories = () => {
    if (!lineItems?.length) return null;
    return lineItems.map((item, index) => {
      const product = products?.find((p) => p.id === item.productId);
      return (
        <ToastOrderSummaryLineItem
          key={item.UUID ?? index}
          product={product}
          item={item}
          action={action}
          isBonusLineItem={item.bonusLineItem}
        />
      );
    });
  };
  return (
    <div data-testid="product-toast-line-items" className="flex flex-col">
      {renderAccessories()}
    </div>
  );
};

type ToastOrderSummaryLineItemsProps = {
  products: GetCartLineProductsQueryResult;
  lineItems: BasketModel["accessories"];
  action?: (
    prevState: ResponseMessage,
    formData: FormData,
  ) => ResponseMessage | Promise<ResponseMessage>;
};
